export default __webpack_public_path__ + "static/media/expand-icon.0d889c0b.svg";